import { aetherApiRequest } from "./client";
import { useQuery } from "react-query";
const fetchLessonVocabulary = (lessonId, version, ctkToken) => {
  return aetherApiRequest({
    url: `/cw/lesson/vocab/${lessonId}/${version}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${ctkToken}`,
      "Content-Type": "application/json"
    }
  }).catch(() => {
    console.warn("Lesson vocabulary not found");
    return {};
  });
};
const useLessonVocabularyQuery = (lessonId, version, ctkToken) => {
  return useQuery(
    ["lessonVocab"],
    () => fetchLessonVocabulary(lessonId, version, ctkToken),
    {
      useErrorBoundary: true,
      enabled: !!lessonId && !!version && !!ctkToken
    }
  );
};
export {
  useLessonVocabularyQuery
};
